export default class VacationDayAllowanceEntity {
    static getEntityData(elem: any) {
        return {
            uuid: elem.querySelector("#vacation_day_allowances_uuid") ? (elem.querySelector("#vacation_day_allowances_uuid") as HTMLInputElement).value : null,
            from: (elem.querySelector("#vacation_day_allowances_from") as HTMLInputElement).value,
            to: (elem.querySelector("#vacation_day_allowances_to") as HTMLInputElement).value,
            amount: (elem.querySelector("#vacation_day_allowances_amount") as HTMLInputElement).value,
        }
    }
}